import { CompanyResponseDto } from '@planning/app/api'
import { EventTypes } from '@planning/messages/eventsTypes'
import { GetCompaniesByIdsQuery } from '@planning/messages/queries/getCompaniesByIdsQueryHandler'
import { GetCompanyByIdQuery } from '@planning/messages/queries/getCompanyByIdQueryHandler'
import { IEvent, IMessageBus } from '@tom-ui/utils'
import _ from 'lodash'
import { action, makeObservable } from 'mobx'
import { ItemStore } from '../base/ItemStore'
import { IEntityStore } from '../types'
import { CompanyItem, ICompanyItem } from './CompanyItem'

export class CompanyItemStore
  extends ItemStore<CompanyResponseDto, ICompanyItem>
  implements IEntityStore<ICompanyItem>
{
  constructor(readonly messageBus: IMessageBus) {
    super((key, data) => new CompanyItem(key, data), {
      messageBus,
      fetchFunc: (id: number) => new GetCompanyByIdQuery(id),
      bulkFetchFunc: (ids: number[]) => new GetCompaniesByIdsQuery(ids),
    })

    makeObservable(this, {
      receiveEntityMessage: action,
      receiveEntitiesMessage: action,
      receiveDeletedEventMessage: action,
    })

    messageBus.subscribeEvent(GetCompanyByIdQuery.type, this.receiveEntityMessage)
    messageBus.subscribeEvent(GetCompaniesByIdsQuery.type, this.receiveEntitiesMessage)
    messageBus.subscribeEvent(EventTypes.CompanyUpsertedInternalEvent, this.receiveEntityMessage)
    messageBus.subscribeEvent(
      EventTypes.CompanyDeletedInternalEvent,
      this.receiveDeletedEventMessage,
    )
  }

  receiveEntityMessage = (event: IEvent<CompanyResponseDto>): void => {
    if (event.payload) {
      this.upsert(event.payload)
    }
  }

  receiveEntitiesMessage = (event: IEvent<CompanyResponseDto[]>): void => {
    if (event.payload) {
      this.upsertBulk(event.payload)
    }
  }

  receiveDeletedEventMessage = (event: IEvent<number>): void => {
    if (event.payload && _.has(this.elements, event.payload)) {
      this.delete(event.payload)
    }
  }
}
